import React from "react";

import { useRequiredFormFieldContext } from "./_context";
import { useFormFieldDelayedError } from "./_use-form-field-delayed-error";
import { FormMessage, type FormMessageProps } from "./message";

export type FormFieldErrorMessageProps = Omit<FormMessageProps, "children">;

/**
 * The explicit error message for a FormField.
 * The component picks up the error from the FormField context.
 */
export const FormFieldErrorMessage: React.FC<FormFieldErrorMessageProps> = (props) => {
	const { state } = useRequiredFormFieldContext();

	const delayedErrorMessage = useFormFieldDelayedError(state);

	if (delayedErrorMessage == null) {
		return null;
	}

	return (
		<FormMessage variant="error" {...props}>
			{delayedErrorMessage}
		</FormMessage>
	);
};
